import React, { useEffect, useState } from 'react'
import { Box, Button, Divider, Typography } from '@material-ui/core'
import { useStyles } from './styles'
import { VisibilityOutlined, VisibilityOffOutlined } from '@material-ui/icons'
import {
  XAxis,
  YAxis,
  VerticalGridLines,
  HorizontalGridLines,
  FlexibleXYPlot,
  VerticalBarSeries,
  ChartLabel,
  Hint,
  Crosshair,
  Highlight,
  LabelSeries,
  AreaSeries,
  GradientDefs,
  LineSeries
} from 'react-vis'
import moment from 'moment'
import { timeZoneAbbrs } from '../../utils/momentTimezones'

const axisStyle = {
  ticks: {
    fontSize: '10px',
    fill: '#a1aab3',
  },
  line: {
    stroke: '#a1aab3',
  },
  title: {
    fontSize: '10px',
    fill: '#7b8793'
  },
}

moment.fn.zoneName = function () {
  const abbr = this.zoneAbbr()
  return timeZoneAbbrs[abbr] || abbr
}

function EnergyPowerGraph(props) {
  const classes = useStyles()
  const [showGraph, setShowGraph] = useState(true)
  const [energyData, setEnergyData] = useState([])
  const [powerData, setPowerData] = useState([])
  const [maxYEnergyValue, setMaxYEnergyValue] = useState(10)
  const [minYPowerValue, setMinYPowerValue] = useState(0)
  const [maxYPowerValue, setMaxYPowerValue] = useState(10)
  const [maxPowerValue, setMaxPowerValue] = useState(10)
  const [crossHairValues, setCrossHairValues] = useState([])
  const [energyAreaData, setEnergyAreaData] = useState([])
  const [powerAreaData, setPowerAreaData] = useState([])
  const [location, setLocation] = useState(null)
  const [hideCrosshair, setHideCrossHair] = useState(false)

  const getGraphData = () => {
    const graphEnergyData = [], graphPowerData = [], energyAreaData = [], powerAreaData = []
    let startInserted = false, endInserted = false
    const { eventId, eventDetails, graphData } = props
    let minPowVal = graphData.current_power && Math.min(-10, Math.min(...graphData.current_power.map(power => (power / 1000).toFixed(2))))
    let maxPowVal = graphData.current_power && Math.max(10, Math.max(...graphData.current_power.map(power => (power / 1000).toFixed(2))))
    let maxEnergyVal = graphData.available_energy_wh && Math.max(10, Math.max(...graphData.available_energy_wh.map(energy => (energy / 1000).toFixed(2))))
    graphData.current_power && setMinYPowerValue(minPowVal)
    graphData.current_power && setMaxYPowerValue(maxPowVal)
    graphData.available_energy_wh && setMaxYEnergyValue(maxEnergyVal)
    let maxVal
    if (Math.abs(minPowVal) > Math.abs(maxPowVal)) {
      maxVal = minPowVal * -1
      setMaxPowerValue(minPowVal * -1)
    } else {
      maxVal = maxPowVal
      setMaxPowerValue(maxPowVal)
    }
    let maxEnergyValue = Math.max(maxYEnergyValue + 2, Math.floor(maxYEnergyValue * 1.1))
    let maxPowerValue = Math.max(maxVal + 2, Math.floor(maxVal * 1.1))
    eventDetails && energyAreaData.push({ x: moment(eventDetails.start_date_time).unix(), y: maxEnergyValue, label: `Event`, yOffset: -10, xOffset: -50, start: true })
    eventDetails && energyAreaData.push({ x: moment(eventDetails.start_date_time).unix(), y: maxEnergyValue, label: `Start Time`, yOffset: 0, xOffset: -50, start: true })
    eventDetails && energyAreaData.push({ x: moment(eventDetails.end_date_time).unix(), y: maxEnergyValue, label: `Event`, yOffset: -10, xOffset: 5, start: false })
    eventDetails && energyAreaData.push({ x: moment(eventDetails.end_date_time).unix(), y: maxEnergyValue, label: `End Time`, yOffset: 0, xOffset: 5, start: false })
    eventDetails && powerAreaData.push({ x: moment(eventDetails.start_date_time).unix(), y: maxPowerValue, label: `Event`, yOffset: -10, xOffset: -50, start: true })
    eventDetails && powerAreaData.push({ x: moment(eventDetails.start_date_time).unix(), y: maxPowerValue, label: `Start Time`, yOffset: 0, xOffset: -50, start: true })
    eventDetails && powerAreaData.push({ x: moment(eventDetails.end_date_time).unix(), y: maxPowerValue, label: `Event`, yOffset: -10, xOffset: 5, start: false })
    eventDetails && powerAreaData.push({ x: moment(eventDetails.end_date_time).unix(), y: maxPowerValue, label: `End Time`, yOffset: 0, xOffset: 5, start: false })
    graphData.available_energy_wh && graphData.available_energy_wh.forEach((energy, index) => {
      if ((moment(eventDetails.start_date_time).unix() < graphData.epochs[index]) && !startInserted) {
        // graphEnergyData.push({ x: moment(eventDetails.start_date_time).unix(), y: null })
        // graphPowerData.push({ x: moment(eventDetails.start_date_time).unix(), y: Math.min(-10, Math.max(...graphData.current_power.map(power => (power / 1000).toFixed(2))) * -1) })
        startInserted = true
      }
      if ((moment(eventDetails.end_date_time).unix() < graphData.epochs[index]) && !endInserted) {
        // graphEnergyData.push({ x: moment(eventDetails.end_date_time).unix(), y: null })
        // graphPowerData.push({ x: moment(eventDetails.end_date_time).unix(), y: Math.min(-10, Math.max(...graphData.current_power.map(power => (power / 1000).toFixed(2))) * -1) })
        endInserted = true
      }
      graphEnergyData.push({ x: graphData.epochs[index], y: (energy / 1000).toFixed(2), label: 'energy', energy: (energy / 1000).toFixed(2), power: (graphData.current_power[index] / 1000).toFixed(2), time: moment.unix(graphData.epochs[index]).tz(props.timeZone).format('DD/MM/YYYY hh:mm A') })
      graphPowerData.push({ x: graphData.epochs[index], y: (graphData.current_power[index] / 1000).toFixed(2), label: 'power', energy: (energy / 1000).toFixed(2), power: (graphData.current_power[index] / 1000).toFixed(2), time: moment.unix(graphData.epochs[index]).tz(props.timeZone).format('DD/MM/YYYY hh:mm A'), y0: 0 })
    })
    setEnergyData(graphEnergyData)
    setPowerData(graphPowerData)
    setEnergyAreaData(energyAreaData)
    setPowerAreaData(powerAreaData)
  }

  const updateGraph = () => {
    const newEnergyData = energyData?.filter(data => data.x >= location.left && data.x <= location.right)
    const newPowerData = powerData?.filter(data => data.x >= location.left && data.x <= location.right)
    const newEnergyAreaData = energyAreaData?.filter(data => data.x >= location.left && data.x <= location.right)
    const newPowerAreaData = powerAreaData?.filter(data => data.x >= location.left && data.x <= location.right)
    setEnergyData(newEnergyData)
    setPowerData(newPowerData)
    setEnergyAreaData(newEnergyAreaData)
    setPowerAreaData(newPowerAreaData)
  }

  useEffect(() => {
    if (location && (location.left && location.right))
      updateGraph()
  }, [location])

  useEffect(() => {
    if (props.graphData)
      getGraphData()
  }, [props.graphData, minYPowerValue, maxYPowerValue, maxYEnergyValue])

  return (
    <Box className={classes.contentWrapper} mt={3.75}>
      <Box display="flex" justifyContent="space-between" className={classes.contentTitle} p={1}>
        <Box>Energy and Power Graph</Box>
        {showGraph ? <VisibilityOffOutlined className={classes.eyeIcon} onClick={() => setShowGraph(showGraph => !showGraph)} /> : <VisibilityOutlined className={classes.eyeIcon} onClick={() => setShowGraph(showGraph => !showGraph)} />}
      </Box>
      {showGraph &&
        <Box m={3} className={classes.graphContainer}>
          {location && (location.left && location.right) &&
            <Box display="flex" justifyContent="flex-end">
              <Button color="primary" onClick={() => { setLocation(null); getGraphData() }}>Reset</Button>
            </Box>
          }
          <Box className={classes.graphWrapper}>
            <FlexibleXYPlot
              height={300}
              xType="linear"
              yDomain={[0, Math.max(maxYEnergyValue + 2, Math.floor(maxYEnergyValue * 1.1))]}
              margin={{ bottom: 50, right: 20, left: 60 }}
              onMouseLeave={() => { setCrossHairValues([]) }}
            >
              <GradientDefs>
                <linearGradient id="EnergyGradient" x1="0" x2="0" y1="0" y2="1">
                  <stop offset="0%" stopColor="#D7E5F5" stopOpacity={1} />
                </linearGradient>
              </GradientDefs>
              <HorizontalGridLines />
              <VerticalBarSeries
                color='#387AD5'
                onNearestX={(value, { event, innerX, index }) => {
                  setCrossHairValues([energyData[index], powerData[index]])
                }}
                data={energyData}
                style={{ position: 'relative' }}
              />
              {energyAreaData && energyAreaData.map(data => (<LineSeries stroke={data.start ? '#6AC13B' : '#E25838'} ytype='linear' strokeStyle='dashed' data={[{ x: data.x, y: 0 }, { x: data.x, y: Math.max(maxYEnergyValue + 2, Math.floor(maxYEnergyValue * 1.1)) }]} />))}
              <LabelSeries className={classes.seriesLabel} data={energyAreaData} labelAnchorX="start" />
              <XAxis
                style={axisStyle}
                tickLabelAngle={window.innerWidth <= 900 ? -45 : 0}
                tickValues={props.graphData.epochs}
                tickFormat={(t, i) => {
                  if (((i + 1) % Math.floor(energyData.length / 9) === 0) || energyData.length < 9) {
                    return `${moment.unix(t).tz(props.timeZone).format('hh:mm A')}`
                  } else {
                    return
                  }
                }}
              />
              <YAxis style={axisStyle} />
              <ChartLabel
                text="Energy (kWh)"
                includeMargin={true}
                style={{
                  transform: 'rotate(-90)',
                  textAnchor: 'end',
                  color: '#a1aab3',
                  fontSize: '12px',
                }}
              />
              <Highlight
                color="#829AE3"
                enableY={false}
                onDrag={area => {
                  setLocation({
                    left: location.left - (area.right - area.left),
                    right: location.right - (area.right - area.left),
                  })
                }}
                onBrushStart={() => setHideCrossHair(true)}
                onBrushEnd={area => { setHideCrossHair(false); setLocation(area) }}
              />
              {energyData && !hideCrosshair && crossHairValues[0] && crossHairValues[0].energy &&
                <Crosshair values={crossHairValues} className={`${classes.crossHair} ${classes.hint}`}>
                  <Box className={`${classes.hintCard} custom-hintbox`}>
                    <Box>
                      <Box className={`${classes.hintTextWrapper}`}>
                        <Typography className={classes.cardKey}>Time:</Typography>
                        <Typography className={classes.cardValue}>{moment.unix(crossHairValues[0]?.x).tz(props.timeZone).format('DD/MM/YYYY h:mm A zz')}</Typography>
                      </Box>
                      <Box className={`${classes.hintTextWrapper}`}>
                        <Typography className={classes.cardKey}>Energy:</Typography>
                        <Typography className={classes.cardValue}>{crossHairValues[0]?.energy}kWh</Typography>
                      </Box>
                    </Box>
                  </Box>
                </Crosshair>
              }
            </FlexibleXYPlot>
          </Box>
          <Box className={classes.graphWrapper}>
            <FlexibleXYPlot
              height={300}
              xType="linear"
              yDomain={[(Math.max(maxPowerValue + 2, Math.floor(maxPowerValue * 1.1)) * -1), Math.max(maxPowerValue + 2, Math.floor(maxPowerValue * 1.1))]}
              margin={{ bottom: 50, right: 20, left: 60 }}
              onMouseLeave={() => { setCrossHairValues([]) }}
            >
              <GradientDefs>
                <linearGradient id="PowerGradient" x1="0" x2="0" y1="0" y2="1">
                  <stop offset="0%" stopColor="#FBEAD5" stopOpacity={1} />
                </linearGradient>
              </GradientDefs>
              <HorizontalGridLines />
              <VerticalBarSeries
                getNull={(d) => d.y !== null}
                color="#F09035"
                onNearestX={(value, { event, innerX, index }) => {
                  setCrossHairValues([energyData[index], powerData[index]])
                }}
                data={powerData}
                style={{ position: 'relative' }}
              />
              {powerAreaData && powerAreaData.map(data => (<LineSeries stroke={data.start ? '#6AC13B' : '#E25838'} yType='linear' strokeStyle='dashed' data={[{ x: data.x, y: Math.max(maxPowerValue + 2, Math.floor(maxPowerValue * 1.1)) * -1 }, { x: data.x, y: Math.max(maxPowerValue + 2, Math.floor(maxPowerValue * 1.1)) }]} />))}
              <LabelSeries className={classes.seriesLabel} data={powerAreaData} labelAnchorX="start" />
              <XAxis
                style={axisStyle}
                tickLabelAngle={window.innerWidth <= 900 ? -45 : 0}
                tickValues={props.graphData.epochs}
                tickFormat={(t, i) => {
                  if (((i + 1) % Math.floor(powerData.length / 9) === 0) || powerData.length < 9) {
                    return `${moment.unix(t).tz(props.timeZone).format('hh:mm A')}`
                  } else {
                    return
                  }
                }}
              />
              <XAxis
                style={axisStyle}
                on0={true}
                tickFormat={(t, i) => {
                  return
                }}
              />
              <YAxis style={axisStyle} />
              <ChartLabel
                text="Power (kW)"
                includeMargin={true}
                style={{
                  transform: 'rotate(-90)',
                  textAnchor: 'end',
                  color: '#a1aab3',
                  fontSize: '12px',
                }}
              />
              <Highlight
                color="#829AE3"
                enableY={false}
                onDrag={area => {
                  setLocation({
                    left: location.left - (area.right - area.left),
                    right: location.right - (area.right - area.left),
                  })
                }}
                onBrushStart={() => setHideCrossHair(true)}
                onBrushEnd={area => { setHideCrossHair(false); setLocation(area) }}
              />
              {powerData && !hideCrosshair && crossHairValues[1] && crossHairValues[1].power &&
                <Crosshair values={crossHairValues} className={`${classes.crossHair} ${classes.hint}`}>
                  <Box className={`${classes.hintCard} custom-hintbox`}>
                    <Box>
                      <Box className={`${classes.hintTextWrapper}`}>
                        <Typography className={classes.cardKey}>Time:</Typography>
                        <Typography className={classes.cardValue}>{crossHairValues[0] ? moment.unix(crossHairValues[0]?.x).tz(props.timeZone).format('DD/MM/YYYY h:mm A zz') : '-'}</Typography>
                      </Box>
                      <Box className={`${classes.hintTextWrapper}`}>
                        <Typography className={classes.cardKey}>Power:</Typography>
                        <Typography className={classes.cardValue}>{crossHairValues[1]?.power}kW</Typography>
                      </Box>
                    </Box>
                  </Box>
                </Crosshair>
              }
            </FlexibleXYPlot>
          </Box>
        </Box>
      }
    </Box>
  )
}

export default EnergyPowerGraph